import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const DocumentSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M10 3L17 3L17 15C17 18.3137 14.3137 21 11 21L6 21L6 7C6 4.79086 7.79086 3 10 3Z"
				fill="url(#paint0_linear_13382_131580)"
			/>
			<path d="M10 3L18 3L18 17C18 19.2091 16.2091 21 14 21L10 21L10 3Z" fill="#4A4A4A" />
			<path
				d="M15.5003 6C15.7763 6 16 6.22373 16 6.49971C16 6.7757 15.7763 6.99943 15.5003 6.99943L8.4997 6.99943C8.22372 6.99943 7.99999 6.7757 7.99999 6.49971C7.99999 6.22373 8.22372 6 8.4997 6L15.5003 6Z"
				fill="white"
			/>
			<path
				d="M15.5003 8.99902C15.7763 8.99902 16 9.22275 16 9.49874C16 9.77472 15.7763 9.99845 15.5003 9.99845L8.4997 9.99845C8.22372 9.99845 7.99999 9.77472 7.99999 9.49874C7.99999 9.22275 8.22372 8.99902 8.4997 8.99902L15.5003 8.99902Z"
				fill="white"
			/>
			<path
				d="M12.5003 11.999C12.7763 11.999 13 12.2228 13 12.4987C13 12.7747 12.7763 12.9985 12.5003 12.9985L8.49973 12.9985C8.22375 12.9985 8.00002 12.7747 8.00002 12.4987C8.00002 12.2228 8.22375 11.999 8.49973 11.999L12.5003 11.999Z"
				fill="white"
			/>
			<defs>
				<linearGradient id="paint0_linear_13382_131580" x1="5" y1="22.35" x2="5" y2="3" gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
			</defs>
		</IPortIconTemplate>
	)
})
